module.exports = __webpack_public_path__ + "static/media/NEXO.64014423.svg";